import type { ReactNode } from 'react';

import { ListingViewActionButtonsHolder } from './ListingViewActionButtons.styled';

type Props = {
  children: ReactNode;
};

export function ListingViewActionButtons({ children }: Props) {
  return (
    <ListingViewActionButtonsHolder>{children}</ListingViewActionButtonsHolder>
  );
}
